import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import { useCodeSystems } from 'src/careflow/ph-core/fhir-client/fhir-react';
import DataTable, { DataTableColumn } from 'src/components/table/DataTable';
import DisenrollmentReasonsToolbar from './DisenrollmentReasonsToolbar';
import DisenrollmentReasonsContextMenu from './DisenrollmentReasonsContextMenu';
import Label from 'src/components/Label';
import { CodeSystemConcept } from 'src/careflow/ph-core/fhir-client/resources';
import { useEffect } from 'react';

const columns = [
  {
    header: 'Reason',
    field: 'display',
  },
  {
    header: 'Status',
    field: 'property',
    render(value: CodeSystemConcept['property']) {
      const active =
        !value ||
        value.length === 0 ||
        value.find((p) => p.code === 'active')?.valueBoolean === true;

      return <Label color={active ? 'success' : 'info'}>{active ? 'Active' : 'Inactive'}</Label>;
    },
  },
] as DataTableColumn[];

export default function DisenrollmentReasonsTable() {
  const [[disenrollmentReasonsCodeSystem], { refresh }] = useCodeSystems({
    filter: {
      _id: 'ccm-program-disenrollment-reasons',
    },
  });

  const disenrollmentReasons = disenrollmentReasonsCodeSystem?.concept || [];

  useEffect(() => {
    refresh();
  }, []);

  return (
    <Box>
      <DisenrollmentReasonsToolbar />

      <DataTable
        selectable
        columns={columns}
        data={disenrollmentReasons}
        rowContextMenu={(item) => <DisenrollmentReasonsContextMenu item={item} />}
      />
    </Box>
  );
}
